export type VoiceCallDisconnectAttributionLike = {
    readonly source?: string | null;
    readonly status?: string | null;
    readonly disconnected_by?: string | null;
    readonly hangup_actor?: string | null;
    readonly label?: string | null;
    readonly details_available?: boolean | null;
    readonly assistant_end_call_requested?: boolean | null;
};

export function getDisconnectAttributionLabel(
    attribution: VoiceCallDisconnectAttributionLike | null | undefined,
): string | null {
    if (attribution?.details_available === false) {
        return null;
    }

    const label = attribution?.label?.trim();
    return label ? label : null;
}

export function getDisconnectAttributionSourceLabel(
    attribution: VoiceCallDisconnectAttributionLike | null | undefined,
): string | null {
    if (!attribution) {
        return null;
    }

    if (attribution.assistant_end_call_requested) {
        return 'Phoebe end-call tool';
    }

    // Diagnostic timelines call this helper even when there is no displayable
    // actor label so they can explain why attribution details are absent.
    if (attribution.details_available === false) {
        return 'Voice Insights unavailable';
    }

    if (attribution.source === 'twilio_voice_insights') {
        return 'Twilio Voice Insights';
    }

    return null;
}

export function isPhoebeDisconnectAttribution(
    attribution: VoiceCallDisconnectAttributionLike | null | undefined,
): boolean {
    return (
        attribution?.hangup_actor === 'phoebe' &&
        attribution.assistant_end_call_requested !== true
    );
}
